var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenPlusIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 11.5C5.58716 11.5 5.25264 11.1655 5.25264 10.7526V1.24736C5.25264 0.83452 5.58716 0.5 6 0.5C6.41284 0.5 6.74736 0.83452 6.74736 1.24736V10.7526C6.74736 11.1655 6.41284 11.5 6 11.5Z",
    fill: "#2999BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7526 6.74736H1.24736C0.83452 6.74736 0.5 6.41284 0.5 6C0.5 5.58716 0.83452 5.25264 1.24736 5.25264H10.7526C11.1655 5.25264 11.5 5.58716 11.5 6C11.5 6.41284 11.1655 6.74736 10.7526 6.74736Z",
    fill: "#2999BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenPlusIcon);
export default __webpack_public_path__ + "static/media/greenPlusIcon.cb4be2482e115ff783c0d35547ee2152.svg";
export { ForwardRef as ReactComponent };